import { db, type SchemaTableRow } from './schema';
export type PayrollOpPackageListRow = {
  operationPackageId: string;
  inProgressCount: number;
};
export type PayrollOpPackagePatternRow = {
  operationPackagePatternId: string;
  nameKey: string;
};
export type PayrollOpPackageInstancesPage = {
  items: SchemaTableRow[];
  count: number;
  maxPage: number;
};
export async function listPayrollOpPackages(): Promise<PayrollOpPackageListRow[]> {
  const rows = await db.payrollOpPackages.toArray();
  rows.sort((a, b) => a.groupIndex - b.groupIndex || a.sortOrder - b.sortOrder || a.id.localeCompare(b.id));
  return rows.map(r => ({
    operationPackageId: r.id,
    inProgressCount: r.inProgressCount
  }));
}
export async function listPayrollOpPackagePatterns(packageId: string): Promise<PayrollOpPackagePatternRow[]> {
  const rows = await db.payrollOpPackagePatterns.where('packageId').equals(packageId).sortBy('sortOrder');
  return rows.map(r => ({
    operationPackagePatternId: r.id,
    nameKey: r.nameKey
  }));
}
export async function listPayrollOpPackageInstancesByPattern(patternId: string, options?: {
  page?: number;
  pageSize?: number;
  targetId?: string;
}): Promise<PayrollOpPackageInstancesPage> {
  const page = options?.page ?? 1;
  const pageSize = options?.pageSize ?? 50;
  const targetId = options?.targetId;
  let rows = await db.payrollOpPackageInstanceItems.where('patternId').equals(patternId).sortBy('sortOrder');
  if (targetId) {
    rows = rows.filter(r => r.row.target.targetId === targetId);
  }
  const count = rows.length;
  const maxPage = Math.max(1, Math.ceil(count / pageSize));
  const start = (page - 1) * pageSize;
  const items = rows.slice(start, start + pageSize).map(r => r.row);
  return {
    items,
    count,
    maxPage
  };
}
export async function getPayrollOpPackagePatternTaskCount(_operationPackageId: string, patternId: string): Promise<{
  operationPackagePatternId: string;
  count: number;
}> {
  const n = await db.payrollOpPackageInstanceItems.where('patternId').equals(patternId).count();
  return {
    operationPackagePatternId: patternId,
    count: n
  };
}